/// Menu
import Metismenu from "metismenujs";
import React, { Component, Suspense, lazy, useContext, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom/cjs/react-router-dom";
import { Dropdown, Modal } from "react-bootstrap";
//import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import LogoutPage from './Logout';
import ChangePassword from "./ChangePassword";

/// Image
//import user from "../../../images/user.jpg";

import profile from "../../../images/user.jpg";
import Tenants from "../../pages/admin/tenant/Tenants";
import AreaBar from "../../pages/admin/Areas/Area"
import YoutubeVideo from "../../pages/admin/Youtube/Youtube"
import SocialLinks from "../../pages/admin/social_links/SocialLinks";
import Banner from "../../pages/admin/banner/Banner";
import Branches from "../../pages/admin/branches/Branches";
import States from "../../pages/admin/states/States";
import HeaderTypes from "../../pages/admin/headertype/HeaderTypes";
import { sub } from "date-fns";


const AboutSlider = lazy(() => import('../../pages/admin/AboutSlider'));
const Article = lazy(() => import('../../pages/admin/Article'));
const FAQ = lazy(() => import('../../pages/admin/FAQ'));
const Privacy = lazy(() => import('../../pages/admin/Privacy'));
const Terms = lazy(() => import('../../pages/admin/Terms'));
const Events = lazy(() => import('../../pages/admin/event/Events'));
const News = lazy(() => import('../../pages/admin/news/News'));
const Logo = lazy(() => import('../../pages/admin/logo/Logo'));
const Image = lazy(() => import('../../pages/admin/sliderimages/Image'));
class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = () => {
  const [postModal, setPostModal] = useState(false);
  const [modaltype, setModalType] = useState(0);
  const [showsidebar, setShowsidebar] = useState(true);
  const [subadminbar, setSubAdminbar] = useState(true);
  const [admin, setAdmin] = useState(false)
  const [name, setName] = useState([])
  const [college, setCollege] = useState(true);
  const [supportuser, setSupportUser] = useState(true);
  const [supportScreen, setSupportScreen] = useState(true)
  const [politicalUser, setPoliticalUser] = useState(false)




  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
  } = useContext(ThemeContext);
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");
    function toggleFunc() {
      return aaa.classList.toggle("menu-toggle");
    }
    btn.addEventListener("click", toggleFunc);

    const constuserdetails = JSON.parse(localStorage.getItem('userDetails'));
    // console.log("constuserdetails",constuserdetails);
    setName(constuserdetails.name)



    if (constuserdetails.roles[0] == 'ROLE_ADMIN') {
      setAdmin(true)
    }



    if (constuserdetails.roles[0] != 'ROLE_ADMIN') {
      setShowsidebar(false);
    }

    if (constuserdetails.roles[0] == 'ROLE_SUBADMIN') {
      setShowsidebar(true);
      setSubAdminbar(false)
      setSupportScreen(false)
    }
    if (constuserdetails.roles[0] == 'ROLE_COLLEGE_ADMIN' || constuserdetails.roles[0] == 'ROLE_SUPPORT_TEAM') {
      setCollege(false)

    }
    if (constuserdetails.roles[0] == 'ROLE_SUPPORT_TEAM') {
      // setSubAdminbar(false)
      setSupportUser(false)

    }
    if (constuserdetails.roles[0] == 'ROLE_COLLEGE_ADMIN') {
      setSupportScreen(false)
    }

    if (constuserdetails.roles[0] == 'ROLE_POLITICAL') {
      // setSupportScreen(false)
      setPoliticalUser(true)
    }

    //sidebar icon Heart blast


  }, []);
  //let scrollPosition = useScrollPosition();
  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];
  /// Active menu
  let deshBoard = [
    "",
    "dashboard-dark",
    "wallet",
    "invoices-list",
    "create-invoices",
    "card-center",
    "transaction-details",
    "task",
  ],
    app = [
      "app-profile",
      "post-details",
      "app-calender",
      "email-compose",
      "email-inbox",
      "email-read",
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "post-details",
      "ecom-product-detail",
    ],
    email = ["email-compose", "email-inbox", "email-read"],
    shop = [
      "ecom-product-grid",
      "ecom-product-list",
      "ecom-product-list",
      "ecom-product-order",
      "ecom-checkout",
      "ecom-invoice",
      "ecom-customers",
      "ecom-product-detail",
    ],
    charts = [
      "chart-rechart",
      "chart-flot",
      "chart-chartjs",
      "chart-chartist",
      "chart-sparkline",
      "chart-apexchart",
    ],
    bootstrap = [
      "ui-accordion",
      "ui-badge",
      "ui-alert",
      "ui-button",
      "ui-modal",
      "ui-button-group",
      "ui-list-group",
      "ui-card",
      "ui-carousel",
      "ui-dropdown",
      "ui-popover",
      "ui-progressbar",
      "ui-tab",
      "ui-typography",
      "ui-pagination",
      "ui-grid",
    ],
    plugins = [
      "uc-select2",

      "uc-sweetalert",
      "uc-toastr",
      "uc-noui-slider",
      "map-jqvmap",
      "uc-lightgallery",
    ],
    redux = [
      "redux-form",
      "redux-wizard",
      "todo",
    ],
    widget = ["widget-basic"],
    forms = [
      "form-element",
      "form-wizard",
      "form-editor-summernote",
      "form-pickers",
      "form-validation-jquery",
    ],
    table = ["table-bootstrap-basic", "table-datatable-basic"],
    pages = [
      "page-register",
      "page-login",
      "page-lock-screen",
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ],
    error = [
      "page-error-400",
      "page-error-403",
      "page-error-404",
      "page-error-500",
      "page-error-503",
    ];

  const openModal = async (type) => {
    setModalType(type);
    setPostModal(true);
  }
  return (
    <>
      <div
        className={`dlabnav ${iconHover} ${sidebarposition.value === "fixed" &&
          sidebarLayout.value === "horizontal" &&
          headerposition.value === "static"
          ? 100 > 120
            ? "fixed"
            : ""
          : ""
          }`}
      >
        <PerfectScrollbar className="dlabnav-scroll">
          <Dropdown className="dropdown header-profile2">
            <Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
              <div className="header-info2 d-flex align-items-center border">
                <img src={profile} width={20} alt="" />
                <div className="d-flex align-items-center sidebar-info">
                  {admin ? <div>
                    <span className="font-w700 d-block mb-2">Visualpath</span>
                    <small className="text-end font-w400">Super Admin</small>
                  </div> : <div>
                    <span className="font-w700 d-block mb-2">{name}</span>
                    <small className="text-end font-w400">Sub Admin</small>
                  </div>}
                  <i className="fas fa-sort-down ms-4"></i>
                </div>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu align="right" className=" dropdown-menu dropdown-menu-center">
              <LogoutPage />
              <ChangePassword />
            </Dropdown.Menu>
          </Dropdown>
          <MM className="metismenu" id="menu">
            {college && !politicalUser  ? <li className={`${deshBoard.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="/dashboard" >
                <i className="fas fa-home"></i>
                <span className="nav-text">Dashboard</span>
              </Link>

            </li> : <li className={`${deshBoard.includes(path) ? "mm-active" : ""}`}>
              {supportuser && !politicalUser && <Link className="has-arrow" to="/collegedashboard" >
                <i className="fas fa-home"></i>
                <span className="nav-text">College Dashboard</span>
              </Link>}

            </li>}


            {(subadminbar && college) && <li className={`${app.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-home"></i>
                <span className="nav-text">Adminstration</span>
              </Link>
              <ul >
                {showsidebar && <>   <li><Link className={`${path === "tenants" ? "mm-active" : ""}`}
                  to="/tenants">Tenant</Link></li>

                  <li><Link className={`${path === "headertypes" ? "mm-active" : ""}`}
                    to={"/headertypes"} >Header Types</Link></li>

                  <li><Link className={`${path === "ustates" ? "mm-active" : ""}`}
                    to={"/ustates"} >State</Link></li>

                  <li><Link className={`${path === "areas" ? "mm-active" : ""}`}
                    to={"/areas"} >Constituency / College</Link></li>

                  <li><Link className={`${path === "districts" ? "mm-active" : ""}`}
                    to={"/districts"} >Districts</Link></li>


                  <li><Link className={`${path === "dashboardlabels" ? "mm-active" : ""}`}
                    to={"/dashboardlabels"} >Dashboard Labels</Link></li>

                  <li><Link className={`${path === "coupons" ? "mm-active" : ""}`}
                    to="/coupons">Coupons</Link></li></>}



                {!politicalUser && <>  <li><Link className={`${path === "banners" ? "mm-active" : ""}`}
                  to={"/banners"} >Banner</Link></li>

                  <li><Link className={`${path === "bannerwebs" ? "mm-active" : ""}`}
                    to={"/bannerwebs"} >Banner Web</Link></li>

                  <li><Link className={`${path === "logos" ? "mm-active" : ""}`}
                    to={"/logos"} >Logo</Link></li></>}

                <li><Link className={`${path === "events" ? "mm-active" : ""}`}
                  to={"/events"} >Event</Link></li>
                <li><Link className={`${path === "news" ? "mm-active" : ""}`}
                  to={"/news"} >Latest News</Link></li>
                <li><Link className={`${path === "youtubevideos" ? "mm-active" : ""}`}
                  to={"/youtubevideos"} >Youtube Videos</Link></li>
                <li><Link className={`${path === "images" ? "mm-active" : ""}`}
                  to={"/images"} >Slider Images</Link></li>
                <li><Link className={`${path === "developments" ? "mm-active" : ""}`}
                  to={"/developments"} >Constituency Developments</Link></li>

                {!politicalUser && <>  <li><Link className={`${path === "announcements" ? "mm-active" : ""}`}
                  to={"/announcements"} >Announcements</Link></li>
                  <li><Link className={`${path === "sociallinks" ? "mm-active" : ""}`}
                    to={"/sociallinks"} >Social Link</Link></li>
                  <li><Link className={`${path === "settings" ? "mm-active" : ""}`}
                    to={"/settings"} >Settings</Link></li>
                  <li><Link className={`${path === "settings" ? "mm-active" : ""}`}
                    to={"/instructor"} >Instructor</Link></li></>}

              </ul>
            </li>}

            {/*============== Masters =============*/}
            {subadminbar && !politicalUser &&<li className={`${app.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-home"></i>
                <span className="nav-text">Users</span>
              </Link>

              <ul >
                {showsidebar && <><li><Link className={`${path === "createusers" ? "mm-active" : ""}`}
                  to="/createusers">Sub Admin</Link></li>

                  <li><Link className={`${path === "collegeadmin" ? "mm-active" : ""}`}
                    to="/collegeadmin">Admins</Link></li></>}


                <li><Link className={`${path === "allusers" ? "mm-active" : ""}`}
                  to="/allusers"> All Users</Link></li>

                {showsidebar && <>    <li><Link className={`${path === "trainingcources" ? "mm-active" : ""}`}
                  to="/trainingcourses"> training courses</Link></li>

                  <li><Link className={`${path === "skills" ? "mm-active" : ""}`}
                    to="/skills">Skills</Link></li>

                  <li><Link className={`${path === "summary" ? "mm-active" : ""}`}
                    to="/summary">Professional Summary</Link></li>

                  <li><Link className={`${path === "enrollment" ? "mm-active" : ""}`}
                    to="/enrollment">Program Enrollment</Link></li>

                  <li><Link className={`${path === "resumeformat" ? "mm-active" : ""}`}
                    to="/resumeformat">Resume Formats</Link></li>

                </>}

              </ul>

            </li>}


            {showsidebar && <>   <li className={`${app.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-home"></i>
                <span className="nav-text">IT Courses</span>
              </Link>
              <ul >
                <li><Link className={`${path === "category" ? "mm-active" : ""}`}
                  to={"/category"} >Category</Link></li>
                <li><Link className={`${path === "category" ? "mm-active" : ""}`}
                  to={"/toplevelprograms"} >Top Level Programs</Link></li>
                <li><Link className={`${path === "programs" ? "mm-active" : ""}`}
                  to={"/programs"} >Programs</Link></li>

                <li><Link className={`${path === "programcourses" ? "mm-active" : ""}`}
                  to={"/programcourses"} >Courses</Link></li>

              </ul>
            </li>

              <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow" to="#" >
                  <i className="fas fa-home"></i>
                  <span className="nav-text">Student Program</span>
                </Link>
                <ul >
                  <li><Link className={`${path === "educations" ? "mm-active" : ""}`}
                    to={"/educations"} >Educations</Link></li>


                  <li><Link className={`${path === "/studentprograms" ? "mm-active" : ""}`}
                    to={"/studentprograms"} >Programs</Link></li>



                </ul>
              </li>

              <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow" to="#" >
                  <i className="fas fa-home"></i>
                  <span className="nav-text">Academics</span>
                </Link>
                <ul >

                  <li><Link className={`${path === "university" ? "mm-active" : ""}`}
                    to={"/university"} >University</Link></li>
                  <li><Link className={`${path === "dashboard-dark" ? "mm-active" : ""}`}
                    to={"/branches"} >Branches</Link></li>
                  <li><Link className={`${path === "semisters" ? "mm-active" : ""}`}
                    to={"/semisters"} >Semisters</Link></li>
                  <li><Link className={`${path === "branchyearprice" ? "mm-active" : ""}`}
                    to={"/branchyearprice"} >Branch-Year Pricing</Link></li>
                  <li><Link className={`${path === "academicstypes" ? "mm-active" : ""}`}
                    to={"/academicstypes"} >Academic Types</Link></li>
                  <li><Link className={`${path === "academics" ? "mm-active" : ""}`}
                    to={"/academics"} >Academic Content</Link></li>


                </ul>
              </li>
              <li className={`${app.includes(path) ? "mm-active" : ""}`}>
                <Link className="has-arrow" to="#" >
                  <i className="fas fa-home"></i>
                  <span className="nav-text">Competitive Exams</span>
                </Link>
                <ul >

                  <li><Link className={`${path === "subjects" ? "mm-active" : ""}`}
                    to={"/subjects"} >Subjects</Link></li>
                  <li><Link className={`${path === "examtype" ? "mm-active" : ""}`}
                    to={"/examtype"} >Exam Type</Link></li>
                  <li><Link className={`${path === "createquestions" ? "mm-active" : ""}`}
                    to={"/createquestions"} >Create Questions</Link></li>
                  <li><Link className={`${path === "exams" ? "mm-active" : ""}`}
                    to={"/exams"} >Exams</Link></li>
                  <li><Link className={`${path === "examrules" ? "mm-active" : ""}`}
                    to={"/examrules"} >Exam Rules</Link></li>



                </ul>
              </li>
            </>}

            {supportScreen && !politicalUser && <li className={`${path === "supportteam" ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="/supportteam" >
                <i className="fas fa-home"></i>
                <span className="nav-text">Support Team</span>
              </Link>

            </li>}
          </MM>
          <div className="copyright">
            <p><strong>Visualpath </strong> © 2023 All Rights Reserved</p>
            <p className="fs-12">Made with  by visualpathedu</p>
          </div>
        </PerfectScrollbar>
      </div>
      <Modal className="modal fade" size="xl" show={postModal} onHide={setPostModal} >
        <div className="" role="document">
          <div className="">
            <form >
              <div className="modal-header">

                <button type="button" className="btn-close" onClick={() => setPostModal(false)} data-dismiss="modal"></button>
              </div>
              <div className="modal-body">

                {
                  modaltype === 1 ? (
                    <Suspense fallback={<div>Loading</div>}>
                      <Tenants /> </Suspense>
                  ) :
                    modaltype === 2 ? (
                      <Suspense fallback={<div>Loading</div>}>
                        <Banner /> </Suspense>
                    ) : modaltype === 3 ? (
                      <Suspense fallback={<div>Loading</div>}>
                        <Logo /> </Suspense>
                    ) : modaltype === 4 ? (
                      <Suspense fallback={<div>Loading</div>}>
                        < AreaBar /> </Suspense>
                    ) : modaltype === 5 ? (
                      <Suspense fallback={<div>Loading</div>}>
                        <Events /> </Suspense>
                    ) : modaltype === 6 ? (
                      <Suspense fallback={<div>Loading</div>}>
                        <News /> </Suspense>
                    ) : modaltype === 7 ? (
                      <Suspense fallback={<div>Loading</div>}>
                        <YoutubeVideo /> </Suspense>
                    ) :
                      modaltype === 8 ? (
                        <Suspense fallback={<div>Loading</div>}>
                          <SocialLinks /> </Suspense>
                      ) :
                        modaltype === 9 ? (
                          <Suspense fallback={<div>Loading</div>}>

                            <Image /> </Suspense>
                        ) :
                          modaltype === 11 ? (
                            <Suspense fallback={<div>Loading</div>}>

                              <States /> </Suspense>
                          ) :
                            modaltype === 13 ? (
                              <Suspense fallback={<div>Loading</div>}>

                                <Branches /> </Suspense>
                            ) :

                              modaltype === 13 ? (
                                <Suspense fallback={<div>Loading</div>}>

                                  <HeaderTypes /> </Suspense>
                              )
                                // :
                                // // modaltype === 14 ? (
                                // //   <Suspense fallback={<div>Loading</div>}>

                                // //     <HeaderTypes /> </Suspense>
                                // // )
                                : null
                }
              </div>

              {/*<div className="modal-footer">
                              <button type="submit" className="btn btn-primary" >Add</button>  
                              <button type="button" onClick={()=> setPostModal(false)} className="btn btn-danger"> <i className="flaticon-delete-1"></i> Discard</button>      
</div>*/}
            </form>

          </div>
        </div>
      </Modal>
    </>
  );
};

export default SideBar;
